module.exports = __webpack_public_path__ + "static/media/1009421.a50cbaf4.png";